import React from "react";
import cn from "classnames";

interface IBaibolPhone {
    additionalClass?: string;
    isMobileHeader?: boolean;
}

const BaibolPhone: React.FC<IBaibolPhone> = ({ isMobileHeader, additionalClass }) => (
    <div
        className={cn(
            isMobileHeader ? 'mobile__footer__phone' : "footer__phone",
            additionalClass
        )}
    >
        <a href="tel:88005505757">8 (800) 550 57 57</a>
        <div className="footer__phone__text">
            {!isMobileHeader && <span>Ежедневно с 9:00 до 21:00</span>}
            <span>Бесплатный звонок по России</span>
        </div>
    </div>
);

export default BaibolPhone;